import { Injectable } from "@angular/core";
import { CommonService } from "../services/common.service";
import * as moment from "moment";
import * as _ from "lodash";

declare let $: any; /* JQUERY */
declare var Cleave: any; /* Cleave js FORMATTER */

@Injectable({
  providedIn: "root",
})
export class FormatterService {
  constructor(public commonService: CommonService) {}

  fullDateWithDayLabel(
    dateString: any,
    dayLabel: boolean = true,
    time: boolean = false
  ) {
    if (dateString && dateString != "") {
      let dayLabelStr = dayLabel
        ? `（${this.commonService.getDayLabel(moment(dateString).day())}）`
        : ``;
      let timeStr = time ? `${moment(dateString).format("HH:mm:ss")}` : ``;
      return `${moment(dateString).format(
        "YYYY年MM月DD日"
      )}${dayLabelStr}${timeStr}`;
    }
    return dateString;
  }
}
